import {useMutation} from "@tanstack/react-query";
import {useModal} from "../../../../../hooks";
import {AxiosError} from "axios";
import {saveDeadlineExchange} from "../../../../../api/order/DeadlineApi";
import {DeadlineSaveExchangeElementType} from "../interface";


export const useSaveDeadlineExchange = () => {
    const {handleModal} = useModal();

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: DeadlineSaveExchangeElementType[]) => saveDeadlineExchange(data),
        onSuccess: () => {
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
